(() => {
    const money = (cents) => {
      const format = document.body.dataset.moneyFormat || 'Tk {{amount}}';
      return format.replace(/\{\{\s*amount[^}]*\}\}/, (cents / 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}));
    };

    window.themeMoney = money;

    document.querySelectorAll('[data-dialog-close]').forEach((button) => {
      button.addEventListener('click', () => button.closest('dialog')?.close());
    });

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-size-guide-open]');
      if (openButton) {
        const dialog = document.getElementById(openButton.getAttribute('aria-controls'));
        dialog?.showModal();
        return;
      }
      const closeButton = event.target.closest('[data-size-guide-close]');
      if (closeButton) closeButton.closest('dialog')?.close();
      if (event.target.matches('[data-size-guide-dialog]')) event.target.close();
    });

    document.querySelectorAll('[data-quantity]').forEach((control) => {
      const input = control.querySelector('input');
      control.querySelectorAll('button').forEach((button) => {
        button.addEventListener('click', () => {
          const change = button.dataset.quantityAction === 'increase' ? 1 : -1;
          input.value = Math.max(Number(input.min || 0), Number(input.value || 0) + change);
          input.dispatchEvent(new Event('change', {bubbles: true}));
        });
      });
    });

    document.querySelectorAll('[data-product-root]').forEach((root) => {
      const variants = JSON.parse(root.querySelector('[data-variants-json]')?.textContent || '[]');
      const optionInputs = [...root.querySelectorAll('[data-option-input]')];
      const variantInput = root.querySelector('[data-variant-id]');
      const price = root.querySelector('[data-product-price]');
      const comparePrice = root.querySelector('[data-product-compare]');
      const saving = root.querySelector('[data-product-saving]');
      const submit = root.querySelector('[data-product-submit]');
      const update = () => {
        root.querySelectorAll('.product-option').forEach((option) => {
          const selectedInput = option.querySelector('[data-option-input]:checked');
          const selectedLabel = option.querySelector('[data-option-label]');
          if (selectedInput && selectedLabel) selectedLabel.textContent = selectedInput.value;
        });
        const selected = [...new Set(optionInputs.map((input) => input.name))].map((name) => root.querySelector(`[name="${CSS.escape(name)}"]:checked`)?.value);
        const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
        if (!variant) return;
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change', {bubbles: true}));
        if (price) price.textContent = money(variant.price);
        const onSale = Number(variant.compare_at_price || 0) > Number(variant.price);
        if (comparePrice) {
          comparePrice.hidden = !onSale;
          comparePrice.textContent = onSale ? money(variant.compare_at_price) : '';
        }
        if (saving) {
          saving.hidden = !onSale;
          saving.textContent = onSale ? saving.dataset.saveTemplate.replace('__amount__', money(variant.compare_at_price - variant.price)) : '';
        }
        if (variant.featured_media?.id) root.querySelector(`[data-gallery-thumb][data-media-id="${CSS.escape(String(variant.featured_media.id))}"]`)?.click();
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? submit.dataset.availableText : submit.dataset.soldOutText;
      };
      optionInputs.forEach((input) => input.addEventListener('change', update));
      update();
    });

    document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
      const root = gallery.closest('[data-product-root]');
      const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
      const items = [...gallery.querySelectorAll('[data-gallery-item]')];
      const zoomTriggers = [...gallery.querySelectorAll('[data-gallery-open]')];
      const zoom = root.querySelector('[data-product-zoom]');
      const zoomImage = zoom?.querySelector('[data-zoom-image]');
      let zoomIndex = 0;
      const showMedia = (index) => {
        items.forEach((item) => item.hidden = Number(item.dataset.mediaIndex) !== Number(index));
        thumbs.forEach((thumb) => thumb.setAttribute('aria-selected', Number(thumb.dataset.mediaIndex) === Number(index) ? 'true' : 'false'));
      };
      const showZoom = (index) => {
        const trigger = zoomTriggers[index];
        if (!trigger || !zoom || !zoomImage) return;
        zoomIndex = index;
        zoomImage.src = trigger.dataset.zoomSrc;
        zoomImage.alt = trigger.dataset.zoomAlt || '';
      };
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaIndex)));
      zoomTriggers.forEach((trigger, index) => trigger.addEventListener('click', () => {
        showZoom(index);
        zoom?.showModal();
      }));
      zoom?.querySelector('[data-zoom-previous]')?.addEventListener('click', () => showZoom((zoomIndex - 1 + zoomTriggers.length) % zoomTriggers.length));
      zoom?.querySelector('[data-zoom-next]')?.addEventListener('click', () => showZoom((zoomIndex + 1) % zoomTriggers.length));
      zoom?.addEventListener('click', (event) => {
        if (event.target === zoom) zoom.close();
      });
    });

    document.querySelectorAll('form.product-form').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        if (!event.submitter?.matches('[data-product-submit]')) return;
        event.preventDefault();
        const submit = form.querySelector('[data-product-submit]');
        const original = submit.textContent;
        submit.disabled = true;
        try {
          document.dispatchEvent(new CustomEvent('theme:cart-open', {detail: {loading: true}}));
          const response = await fetch(document.body.dataset.cartAddUrl, {method: 'POST', body: new FormData(form), headers: {'Accept': 'application/json'}});
          if (!response.ok) throw new Error('Unable to add item');
          const cart = await fetch(document.body.dataset.cartUrl).then((result) => result.json());
          document.dispatchEvent(new CustomEvent('theme:cart-updated', {detail: cart}));
        } catch (error) {
          submit.textContent = document.body.dataset.productError;
        } finally {
          submit.disabled = false;
          submit.textContent = original;
        }
      });
    });

    const revealElements = (root = document) => {
      const elements = [...root.querySelectorAll('[data-reveal]')];
      if (root instanceof Element && root.matches('[data-reveal]')) elements.unshift(root);
      return elements;
    };

    if (window.Shopify?.designMode) {
      const showEditorSection = (root) => revealElements(root).forEach((element) => element.classList.add('is-visible'));
      showEditorSection(document);
      document.addEventListener('shopify:section:load', (event) => showEditorSection(event.target));
      document.addEventListener('shopify:section:select', (event) => showEditorSection(event.target));
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {threshold: .12});
      revealElements(document).forEach((element) => observer.observe(element));
    }
  })();

/* Stock counter — reflects the selected variant's inventory */
(() => {
  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const counter = root.querySelector('[data-stock-counter]');
    const inventoryScript = root.querySelector('[data-inventory-json]');
    const variantInput = root.querySelector('[data-variant-id]');
    if (!counter || !inventoryScript || !variantInput) return;

    let inventory = {};
    try {
      inventory = JSON.parse(inventoryScript.textContent);
    } catch (error) {
      return;
    }

    const threshold = Number(counter.dataset.threshold || 8);

    const render = () => {
      const data = inventory[variantInput.value];
      if (!data) { counter.hidden = true; return; }
      counter.classList.remove('stock-counter--low', 'stock-counter--out');

      if (!data.tracked || data.continue) {
        counter.textContent = counter.dataset.inStock;
        counter.hidden = false;
        return;
      }
      if (data.quantity <= 0) {
        counter.textContent = counter.dataset.soldOut;
        counter.classList.add('stock-counter--out');
        counter.hidden = false;
        return;
      }
      if (data.quantity <= threshold) {
        counter.textContent = counter.dataset.lowTemplate.replace('__count__', data.quantity);
        counter.classList.add('stock-counter--low');
        counter.hidden = false;
        return;
      }
      counter.textContent = counter.dataset.inStock;
      counter.hidden = false;
    };

    variantInput.addEventListener('change', render);
    render();
  });
})();

/* Countdown timer */
(() => {
  const pad = (value) => String(value).padStart(2, '0');

  document.querySelectorAll('[data-countdown]').forEach((countdown) => {
    const end = new Date(countdown.dataset.end).getTime();
    if (Number.isNaN(end)) return;

    const clock = countdown.querySelector('[data-countdown-clock]');
    const expired = countdown.querySelector('[data-countdown-expired]');
    const fields = {
      days: countdown.querySelector('[data-countdown-days]'),
      hours: countdown.querySelector('[data-countdown-hours]'),
      minutes: countdown.querySelector('[data-countdown-minutes]'),
      seconds: countdown.querySelector('[data-countdown-seconds]')
    };

    const finish = () => {
      if (countdown.dataset.hideExpired === 'true') {
        countdown.closest('[data-countdown-section]')?.setAttribute('hidden', '');
        return;
      }
      if (clock) clock.hidden = true;
      if (expired) expired.hidden = false;
    };

    const tick = () => {
      const remaining = end - Date.now();
      if (remaining <= 0) { finish(); return true; }
      const seconds = Math.floor(remaining / 1000);
      fields.days.textContent = pad(Math.floor(seconds / 86400));
      fields.hours.textContent = pad(Math.floor(seconds / 3600) % 24);
      fields.minutes.textContent = pad(Math.floor(seconds / 60) % 60);
      fields.seconds.textContent = pad(seconds % 60);
      return false;
    };

    if (tick()) return;
    const timer = setInterval(() => { if (tick()) clearInterval(timer); }, 1000);
  });
})();

/* Free shipping progress — keeps the cart bar live after AJAX adds */
(() => {
  const bars = [...document.querySelectorAll('[data-shipping-progress]')];
  if (!bars.length) return;

  const refresh = async () => {
    try {
      const cart = await fetch(document.body.dataset.cartUrl).then((result) => result.json());
      bars.forEach((bar) => {
        const threshold = Number(bar.dataset.threshold || 0);
        if (!threshold) return;
        const remaining = threshold - cart.total_price;
        const percent = Math.min(100, Math.round((cart.total_price / threshold) * 100));
        const fill = bar.querySelector('[data-shipping-fill]');
        const message = bar.querySelector('[data-shipping-message]');
        if (fill) fill.style.setProperty('--progress', percent + '%');
        bar.classList.toggle('shipping-progress--complete', remaining <= 0);
        if (message) {
          message.textContent = remaining > 0
            ? bar.dataset.remainingTemplate.replace('__amount__', window.themeMoney(remaining))
            : bar.dataset.completeText;
        }
      });
    } catch (error) {
      /* leave the server-rendered values in place */
    }
  };

  document.addEventListener('theme:cart-updated', refresh);
})();

/* Mobile gallery: swipe between images, pinch/double-tap zoom inside the lightbox */
(() => {
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const root = gallery.closest('[data-product-root]');
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const stage = gallery.querySelector('.product-gallery__stage');
    if (!stage || thumbs.length < 2) return;

    let startX = 0;
    let startY = 0;
    let tracking = false;

    stage.addEventListener('touchstart', (event) => {
      if (event.touches.length !== 1) { tracking = false; return; }
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      tracking = true;
    }, {passive: true});

    stage.addEventListener('touchend', (event) => {
      if (!tracking) return;
      tracking = false;
      const deltaX = event.changedTouches[0].clientX - startX;
      const deltaY = event.changedTouches[0].clientY - startY;
      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) < Math.abs(deltaY) * 1.4) return;
      const current = thumbs.findIndex((thumb) => thumb.getAttribute('aria-selected') === 'true');
      const next = (current + (deltaX < 0 ? 1 : -1) + thumbs.length) % thumbs.length;
      thumbs[next].click();
    }, {passive: true});

    const zoom = root?.querySelector('[data-product-zoom]');
    const image = zoom?.querySelector('[data-zoom-image]');
    if (!zoom || !image) return;

    let scale = 1;
    let panX = 0;
    let panY = 0;
    let pinchStart = 0;
    let panStartX = 0;
    let panStartY = 0;
    let lastTap = 0;

    const apply = () => {
      image.style.transform = `translate(${panX}px, ${panY}px) scale(${scale})`;
      zoom.classList.toggle('product-zoom--zoomed', scale > 1);
    };

    const reset = () => { scale = 1; panX = 0; panY = 0; apply(); };
    zoom.addEventListener('close', reset);
    zoom.querySelectorAll('[data-zoom-previous], [data-zoom-next]').forEach((button) => button.addEventListener('click', reset));

    const distance = (touches) => Math.hypot(
      touches[0].clientX - touches[1].clientX,
      touches[0].clientY - touches[1].clientY
    );

    image.addEventListener('touchstart', (event) => {
      if (event.touches.length === 2) {
        pinchStart = distance(event.touches) / scale;
        return;
      }
      if (event.touches.length === 1) {
        panStartX = event.touches[0].clientX - panX;
        panStartY = event.touches[0].clientY - panY;
        const now = Date.now();
        if (now - lastTap < 300) {
          scale = scale > 1 ? 1 : 2.4;
          panX = 0;
          panY = 0;
          apply();
        }
        lastTap = now;
      }
    }, {passive: true});

    image.addEventListener('touchmove', (event) => {
      if (event.touches.length === 2 && pinchStart) {
        event.preventDefault();
        scale = Math.min(4, Math.max(1, distance(event.touches) / pinchStart));
        if (scale === 1) { panX = 0; panY = 0; }
        apply();
        return;
      }
      if (event.touches.length === 1 && scale > 1) {
        event.preventDefault();
        panX = event.touches[0].clientX - panStartX;
        panY = event.touches[0].clientY - panStartY;
        apply();
      }
    }, {passive: false});

    image.addEventListener('touchend', (event) => {
      if (event.touches.length === 0) pinchStart = 0;
    }, {passive: true});
  });
})();

/* Cart drawer */
(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const itemsList = drawer.querySelector('[data-cart-items]');
  const emptyState = drawer.querySelector('[data-cart-empty]');
  const foot = drawer.querySelector('[data-cart-foot]');
  const subtotal = drawer.querySelector('[data-cart-subtotal]');
  const shipping = drawer.querySelector('[data-drawer-shipping]');
  const shippingMessage = drawer.querySelector('[data-shipping-message]');
  const shippingFill = drawer.querySelector('[data-shipping-fill]');
  const recommends = drawer.querySelector('[data-cart-recommends]');
  const recommendRow = drawer.querySelector('[data-recommend-row]');
  const threshold = Number(drawer.dataset.threshold || 0);
  const money = (cents) => (window.themeMoney ? window.themeMoney(cents) : cents);

  let lastFocus = null;
  let busy = false;

  const open = (loading = false) => {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    drawer.classList.toggle('is-loading', loading);
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    document.body.classList.add('cart-drawer-open');
    drawer.querySelector('[data-cart-close]')?.focus();
  };

  const close = () => {
    drawer.classList.remove('is-open');
    document.body.classList.remove('cart-drawer-open');
    setTimeout(() => { drawer.hidden = true; }, 300);
    lastFocus?.focus();
  };

  const renderShipping = (total) => {
    if (!threshold || !shipping) return;
    const remaining = threshold - total;
    const percent = Math.min(100, Math.round((total / threshold) * 100));
    shipping.hidden = false;
    shipping.classList.toggle('shipping-progress--complete', remaining <= 0);
    shippingFill.style.setProperty('--progress', percent + '%');
    shippingMessage.textContent = remaining > 0
      ? drawer.dataset.remainingTemplate.replace('__amount__', money(remaining))
      : drawer.dataset.completeText;
  };

  const renderItems = (cart) => {
    itemsList.innerHTML = '';
    cart.items.forEach((item, index) => {
      const li = document.createElement('li');
      li.className = 'cart-drawer__item';
      li.innerHTML = `
        <a class="cart-drawer__item-media" href="${item.url}">
          ${item.image ? `<img src="${item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')}" alt="" loading="lazy" width="80" height="80">` : ''}
        </a>
        <div class="cart-drawer__item-info">
          <a class="cart-drawer__item-title" href="${item.url}">${item.product_title}</a>
          ${item.variant_title ? `<p class="cart-drawer__item-variant">${item.variant_title}</p>` : ''}
          <div class="cart-drawer__item-controls">
            <div class="cart-drawer__stepper">
              <button type="button" data-line="${index + 1}" data-qty="${item.quantity - 1}" aria-label="Decrease">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-line="${index + 1}" data-qty="${item.quantity + 1}" aria-label="Increase">+</button>
            </div>
            <strong>${money(item.final_line_price)}</strong>
          </div>
        </div>
        <button class="cart-drawer__remove" type="button" data-line="${index + 1}" data-qty="0" aria-label="Remove">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="m7 7 10 10M17 7 7 17"/></svg>
        </button>`;
      itemsList.appendChild(li);
    });
  };

  const loadRecommends = async (cart) => {
    if (!recommends || !cart.items.length) return;
    try {
      const url = `${drawer.dataset.recommendUrl}?section_id=&product_id=${cart.items[0].product_id}&limit=2&intent=related`;
      const data = await fetch(url.replace('?section_id=&', '?')).then((r) => r.json());
      if (!data.products || !data.products.length) return;
      recommendRow.innerHTML = data.products.slice(0, 2).map((product) => `
        <a class="cart-drawer__recommend" href="${product.url}">
          ${product.featured_image ? `<img src="${product.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')}" alt="" loading="lazy">` : ''}
          <span class="cart-drawer__recommend-title">${product.title}</span>
          <span class="cart-drawer__recommend-price">${money(product.price)}</span>
        </a>`).join('');
      recommends.hidden = false;
    } catch (error) {
      /* recommendations are optional */
    }
  };

  const saving = drawer.querySelector('[data-cart-saving]');

  const renderSaving = (cart) => {
    if (!saving) return;
    const total = cart.total_discount || 0;
    if (total <= 0) { saving.hidden = true; return; }
    saving.textContent = saving.dataset.template.replace('__amount__', money(total));
    saving.hidden = false;
  };

  const render = (cart) => {
    drawer.classList.remove('is-loading');
    renderSaving(cart);
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    const hasItems = cart.item_count > 0;
    emptyState.hidden = hasItems;
    foot.hidden = !hasItems;
    if (shipping) shipping.hidden = !hasItems;
    if (!hasItems) {
      if (saving) saving.hidden = true;
      itemsList.innerHTML = '';
      if (recommends) recommends.hidden = true;
      return;
    }
    renderItems(cart);
    subtotal.textContent = money(cart.total_price);
    renderShipping(cart.total_price);
    loadRecommends(cart);
  };

  const refresh = async () => {
    const cart = await fetch(document.body.dataset.cartUrl).then((r) => r.json());
    render(cart);
    return cart;
  };

  const change = async (line, quantity) => {
    if (busy) return;
    busy = true;
    drawer.classList.add('is-busy');
    try {
      const cart = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({line: Number(line), quantity: Math.max(0, Number(quantity))})
      }).then((r) => r.json());
      render(cart);
    } catch (error) {
      await refresh();
    } finally {
      busy = false;
      drawer.classList.remove('is-busy');
    }
  };

  itemsList.addEventListener('click', (event) => {
    const button = event.target.closest('[data-line]');
    if (!button) return;
    change(button.dataset.line, button.dataset.qty);
  });

  drawer.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  document.querySelectorAll('[data-cart-open]').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      open(true);
      refresh();
    });
  });

  document.addEventListener('theme:cart-updated', (event) => {
    if (event.detail) render(event.detail); else refresh();
  });
  document.addEventListener('theme:cart-open', (event) => open(event.detail?.loading === true));
})();

/* Size guide tabs */
(() => {
  document.querySelectorAll('[data-size-tables]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[data-size-tab]')];
    const panels = [...root.querySelectorAll('[data-size-panel]')];
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((other) => {
          const active = other === tab;
          other.classList.toggle('is-active', active);
          other.setAttribute('aria-selected', String(active));
        });
        panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.sizePanel === tab.dataset.sizeTab);
        });
      });
    });
  });
})();

/* Sticky header — keeps the bar pinned and adds a shadow once scrolled */
(() => {
  const header = document.querySelector('.site-header');
  if (!header) return;

  let wrapper = header.closest('.shopify-section-group-header-group');
  if (!wrapper) {
    // not inside a section group (or older markup): wrap it so sticky has something to hold
    wrapper = header.parentElement;
    if (wrapper) wrapper.classList.add('header-sticky-wrapper');
  }
  if (!wrapper) return;

  const update = () => {
    wrapper.classList.toggle('is-stuck', wrapper.getBoundingClientRect().top <= 0 && window.scrollY > 4);
  };

  update();
  window.addEventListener('scroll', () => requestAnimationFrame(update), {passive: true});
})();

/* Load the second product image only when a real pointer hovers the card */
(() => {
  if (!window.matchMedia('(hover: hover)').matches) return;
  document.querySelectorAll('.product-card').forEach((card) => {
    const hover = card.querySelector('[data-hover-src]');
    if (!hover) return;
    const load = () => {
      hover.src = hover.dataset.hoverSrc;
      hover.removeAttribute('data-hover-src');
    };
    card.addEventListener('pointerenter', load, {once: true});
    card.addEventListener('focusin', load, {once: true});
  });
})();
